export const FETCH_PRODUCT_SUCCESS = 'products/fetchSuccess'

export const FETCH_DETAIL_PRODUCT_SUCCESS = 'products/fetchDetailSuccess'

export const FETCH_CATEGORY_SUCCESS = 'categories/fetchSuccess'